<h1>{{ 'turbo.core.FindLocationDialog.txtHeadline' | translate : 'Find nearby location' }}</h1>
<div *ngIf="!isDefault" class="row" style="width: 770px;">
  <div class="col-xs-6">
    <div class="turboContainer" style="margin-bottom: 10px;">
      <mat-form-field style="width: 100%;">
        <input (keydown.enter)="locationCodeSearch($event)" #txtSearchBox type="text" matInput placeholder="{{ 'turbo.core.FindLocationDialog.tipSearch' | translate : 'Enter location' }}" [required] (focus)="onSearchFocus()" />
      </mat-form-field>
    </div>
    <t4-container height="362px" [isLoading]="loading.locations">
      <div *ngIf="!searchResults">-- {{'Turbo.core.FindLocationDialog.msgNoLocations' | translate : 'Enter a location to search'}} --</div>
      <div *ngIf="searchResults" class="container-fluid">
        <div *ngFor="let item of searchResults" class="row">
          <div class="col-xs-12 list-item" matTooltip="{{ item.Name }}" (click)="selectLocation(item)" [ngClass]="{ 'selected': selectedLocation && selectedLocation.Id == item.Id, 'disabled': (role == 'Pickup' && !item.OpenForPickup) || (role == 'Return' && !item.OpenForReturn) }">
            <div class="col-xs-12">
              <span style="font-weight: bold">{{item.Name}} ({{ item.LocationCode }})</span><br />
              {{ item.Address}}, {{ item.City }}
            </div>
            <div style="position: absolute; top: 0; right: 0;">
              <span style="font-weight: bold">{{ item.Distance | number : '0.1-1'}}km</span>
            </div>
            <div *ngIf="(role == 'Pickup' && !item.OpenForPickup) || (role == 'Return' && !item.OpenForReturn) || (role == 'Pick' && item.IsDeleted)" class="closedOverlay"></div>
            <div *ngIf="(role == 'Pickup' && !item.OpenForPickup)" class="closedMessage">{{'Turbo.core.FindLocationDialog.msgTemporaryClosedForPickup' | translate : 'Temporary closed for pickup' }}</div>
            <div *ngIf="(role == 'Return' && !item.OpenForReturn)" class="closedMessage">{{'Turbo.core.FindLocationDialog.msgTemporaryClosedForReturn' | translate : 'Temporary closed for return' }}</div>
            <div *ngIf="(role == 'Pick' && item.IsDeleted)" class="closedMessage">{{'Turbo.core.FindLocationDialog.msgDeleted' | translate : 'Deleted' }}</div>
          </div>
        </div>
      </div>
    </t4-container>
  </div>
  <div class="col-xs-6">
    <t4-container height="469px">
      <t4-locationInfo *ngIf="selectedLocation" [location]="selectedLocation"></t4-locationInfo>
    </t4-container>
  </div>
</div>
<div *ngIf="isDefault" class="row" style="width: 770px;">
  <div class="col-xs-6">
    <div class="turboContainer" style="margin-bottom: 10px;">
      <mat-form-field style="width: 100%;">
        <input (keydown.enter)="locationInputSearch($event)" #txtInputSearchBox type="text" matInput placeholder="{{ 'turbo.core.FindLocationDialog.tipSearchFreetText' | translate : 'Enter free text' }}" [required] (focus)="onSearchFocus()" />
      </mat-form-field>
    </div>
    <t4-container height="362px" [isLoading]="loading.locations">
      <div *ngIf="!searchResults"> {{'Turbo.core.FindLocationDialog.msgNoLocationInputs' | translate : 'Enter a free text to search'}} </div>
      <div *ngIf="searchResults" class="container-fluid">
        <div *ngFor="let item of searchResults" class="row">
          <div class="col-xs-12 list-item" matTooltip="{{ item.Name }}" (click)="selectLocation(item)" [ngClass]="{ 'selected': selectedLocation && selectedLocation.Id == item.Id, 'disabled': (role == 'Pickup' && !item.OpenForPickup) || (role == 'Return' && !item.OpenForReturn) }">
            <div class="col-xs-12">
              <span style="font-weight: bold">{{item.Name}} ({{ item.LocationCode }})</span><br />
              {{ item.Address}}, {{ item.City }}
            </div>
            <div style="position: absolute; top: 0; right: 0;">
              <span style="font-weight: bold">{{ item.Distance | number : '0.1-1'}}km</span>
            </div>
            <div *ngIf="(role == 'Pickup' && !item.OpenForPickup) || (role == 'Return' && !item.OpenForReturn) || (role == 'Pick' && item.IsDeleted)" class="closedOverlay"></div>
            <div *ngIf="(role == 'Pickup' && !item.OpenForPickup)" class="closedMessage">{{'Turbo.core.FindLocationDialog.msgTemporaryClosedForPickup' | translate : 'Temporary closed for pickup' }}</div>
            <div *ngIf="(role == 'Return' && !item.OpenForReturn)" class="closedMessage">{{'Turbo.core.FindLocationDialog.msgTemporaryClosedForReturn' | translate : 'Temporary closed for return' }}</div>
            <div *ngIf="(role == 'Pick' && item.IsDeleted)" class="closedMessage">{{'Turbo.core.FindLocationDialog.msgDeleted' | translate : 'Deleted' }}</div>
          </div>
        </div>
      </div>
    </t4-container>
  </div>
  <div class="col-xs-6">
    <t4-container height="469px">
      <t4-locationInfo *ngIf="selectedLocation" [location]="selectedLocation"></t4-locationInfo>
    </t4-container>
  </div>
</div>

<button style="float: right; margin-top: 10px;" mat-flat-button color="primary" [mat-dialog-close]="selectedLocation" [disabled]="!selectedLocation">{{ 'turbo.core.FindLocationDialog.cmdSelect' | translate : 'Select' }}</button>
